import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import '../../css/users.css';

function UserCreate() {
  const [form, setForm] = useState({
    userid: '',
    name: '',
    password: '',
    role: 'user',
    phone: '',
    email: '',
    dept_code: '',
    dept_name: '',
    parent_dept_code: '',
    position: '',
    maildb: false,
  });

  const [deptList, setDeptList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const M_ComCode = location.state?.M_ComCode || '';
  const M_ComName = location.state?.M_ComName || '';
  const { token } = useContext(AuthContext);

  // ✅ 부서 목록 불러오기
  useEffect(() => {
    axios.get('/api/dept', {
      headers: { Authorization: `Bearer ${token}`, 'x-com-code': M_ComCode },
    })
    .then(res => setDeptList(res.data))
    .catch(err => {
      console.error('부서 목록 불러오기 실패:', err);
      alert('부서 정보를 불러올 수 없습니다.');
    });
  }, [token, M_ComCode]);

  // ✅ 부서 선택 시 부서 정보 업데이트
  const handleDeptChange = (e) => {
    const selectedCode = e.target.value;
    const selectedDept = deptList.find(d => d.dept_code === selectedCode);
    if (selectedDept) {
      setForm({
        ...form,
        dept_code: selectedDept.dept_code,
        dept_name: selectedDept.dept_name,
        parent_dept_code: selectedDept.parent_dept_code,
      });
    }
  };

  const handleSubmit = async () => {
    try {
      if (!form.userid || !form.password) {
        return alert('아이디와 비밀번호를 입력하세요');
      }

      // ✅ 사용자 + 조직 정보 통합 전송
      await axios.post('/api/auth/register', { ...form, M_ComCode }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert('사용자가 등록되었습니다');
      navigate('/users', { state: { M_ComCode } });
    } catch (err) {
      console.error('사용자 등록 실패:', err);
      alert(err.response?.data?.message || '등록 중 오류 발생');
    }
  };

  return (
    <div className="register-page">
      <div className="register-card">
        
        {/* 상단 헤더 영역 */}
        <div className="card-header">
          <h5 className="mb-0">{M_ComName ? `${M_ComName} 사용자 등록` : '사용자 등록'}</h5>
          <p className="mb-0">새로운 회원을 등록하세요</p>
        </div>

        {/* 폼 영역 */}
        <div className="card-body">
          <form className="needs-validation">

            {/* 아이디 */}
            <div className="mb-3">
              <label className="form-label">아이디</label>
              <input
                type="text"
                className="form-control"
                placeholder="아이디 입력"
                value={form.userid}
                onChange={(e) => setForm({ ...form, userid: e.target.value })}
              />
            </div>

            {/* 이름 */}
            <div className="mb-3">
              <label className="form-label">이름</label>
              <input
                type="text"
                className="form-control"
                placeholder="이름 입력"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </div>

            {/* 비밀번호 */}
            <div className="mb-3">
              <label className="form-label">비밀번호</label>
              <input
                type="password"
                className="form-control"
                placeholder="비밀번호 입력"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>

            {/* 권한 */}
            <div className="mb-3">
              <label className="form-label">권한</label>
              <select
                className="form-select"
                value={form.role}
                onChange={(e) => setForm({ ...form, role: e.target.value })}
              >
                <option value="user">user</option>
                <option value="admin">admin</option>
              </select>
            </div>

            {/* 부서 선택 */}
            <div className="mb-3">
              <label className="form-label">부서</label>
              <select
                className="form-select"
                value={form.dept_code}
                onChange={handleDeptChange}
              >
                <option value="">부서를 선택하세요</option>
                {deptList.map(dept => (
                  <option key={dept.dept_code} value={dept.dept_code}>
                    {dept.dept_name}
                  </option>
                ))}
              </select>
            </div>

            {/* 직책 */}
            <div className="mb-3">
              <label className="form-label">직책</label>
              <input
                type="text"
                className="form-control"
                placeholder="직책 입력"
                value={form.position}
                onChange={(e) => setForm({ ...form, position: e.target.value })}
              />
            </div>
            {/* 연락처 */}
            <div className="mb-3">
              <label className="form-label">연락처</label>
              <input
                type="text"
                className="form-control"
                placeholder="연락처 입력"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="maildbCheck"
                  checked={form.maildb}
                  onChange={(e) => {
                    if (e.target.checked) {
                      // ✅ 체크 시 이메일 값 비우고 비활성화
                      setForm({ ...form, maildb: true, email: '' });
                    } else {
                      // ✅ 체크 해제 시 다시 활성화
                      setForm({ ...form, maildb: false });
                    }
                  }}
            
                />
                <label className="form-check-label" htmlFor="maildbCheck">
                  이메일 자동 생성
                </label>
              </div>
              {/* 안내 문구 영역 */}
              {form.maildb && (
                <small className="text-muted">
                  선택 시 자동으로 메일이 생성되며, 하단에 입력된 이메일 주소와든 다른 이메일주소가 생성될수 있습니다.
                </small>
              )}
            </div>

            {/* 이메일 */}
            <div className="mb-3">
              <label className="form-label">이메일</label>
              <input
                type="email"
                className="form-control"
                placeholder="이메일 입력"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>

            {/* 버튼 영역 */}
            <div className="mt-4 d-grid gap-2">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSubmit}
              >
                등록
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/users')}
              >
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UserCreate;